module.exports = __webpack_public_path__ + "img/mypage07.fa7e3ac8.png";